// Generated by IcedCoffeeScript 108.0.11
(function() {
  var SignatureEngine, burn, processor;

  burn = require('./burner').burn;

  processor = require('./processor');

  SignatureEngine = require('./sigeng').SignatureEngine;

  exports.box = burn;

  exports.unbox = processor.do_message;

  exports.SignatureEngine = SignatureEngine;

}).call(this);
